import { EGetPostPreviewActionType, EResetPostPreviewActionType, TPostPreviewActions } from '../../actions/postPreview';
import { TPostPreviewState } from '../../types/postPreview';
import { ERequestStatus } from '../../types/requestStatus';

export const defaultState: TPostPreviewState = {
  status: ERequestStatus.Initial,
};

export const postPreviewReducer = (state: TPostPreviewState = defaultState, action: TPostPreviewActions) => {
  switch (action.type) {
    case EGetPostPreviewActionType.Succeed:
      return { ...state, ...action.payload, status: ERequestStatus.Succeed };

    case EGetPostPreviewActionType.Failed:
      return { ...state, status: ERequestStatus.Failed };

    case EResetPostPreviewActionType.Reset:
      return defaultState;

    default:
      return state;
  }
};
